/**
 * Created by jv on 17/05/2017.
 */
//js
const log = require("Sources/utils/logger")();
import Shared from "Sources/shared";
import UserServices from "Sources/services/user-services";
import FormValidator from "Sources/components/form-validator";
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import LoginManager from "Sources/services/login-manager";
import StorageController from "Sources/controllers/storage-controller";

//Styles
require("Styles/pages/register.scss");

$(function () {
  Shared.init();
  RegisterPage.init();
});

let RegisterPage = {};

((RegisterPage) => {
  let registerFormValidator;

  RegisterPage.init = function () {
    setUpForm();
    setUpEventListeners();

    $("#page-title").text(LanguageManager.getValueForKey("register.page_title"));
  };

  function setUpForm() {
    registerFormValidator = new FormValidator({
      selector: "#register-form",
      validateOnChange: true,
      rules: {
        email: {
          required: true,
          validator: (value) => {
            return !utils.isNullOrEmpty(value) && value.trim() !== "";
          }
        },
        password: {
          required: true,
          // minLength: 6,
          maxLength: 64,
          validator: (password) => {
            return !utils.isNullOrEmpty(password) && password.trim() !== "";
          }
        },
        passwordRepeat: {
          required: true,
          // minLength: 6,
          maxLength: 64,
          sameAs: "password",
          validator: (password) => {
            return !utils.isNullOrEmpty(password) && password.trim() !== "";
          }
        }
      }
    });
  }

  function setUpEventListeners() {
    $("#register-next-btn").off("click").on("click", (e) => {
      let $formFeedback = $("#register-form-feedback").empty();
      let isValid = registerFormValidator.validate();

      if (isValid) {
        $("#register-form").removeClass("form-active");
        $("#register-eula-form").addClass("form-active");
      } else {
        let formData = registerFormValidator.getFormData();
        if (formData.password !== formData.passwordRepeat) {
          $formFeedback.text(LanguageManager.getValueForKey("register.errors.password_mismatch"));
        }
      }
    });

    let $confirmRegisterBtn = $(".confirm-registration-btn");
    $confirmRegisterBtn.prop("disabled", true);

    let $eulaCheckbox = $("#register-eula-checkbox");
    $eulaCheckbox.prop("checked", false);

    $eulaCheckbox.off("change").on("change", function (e) {
      $confirmRegisterBtn.prop("disabled", !this.checked);
    });

    $confirmRegisterBtn.off("click").on("click", function (e) {
      register();
    });
  }

  function register() {
    let $formFeedback = $("#register-form-feedback").empty();
    let $confirmRegistrationBtn = $(".confirm-registration-btn");

    let isValid = registerFormValidator.validate();

    if (isValid) {
      let formData = registerFormValidator.getFormData();

      let user = {
        username: formData.email,
        email: formData.email,
        password: formData.password
      };

      $confirmRegistrationBtn.prop("disabled", true).addClass("btn-loading");

      UserServices.registerUser(user)
        .then((data) => {
          login(formData.email, formData.password);
        })
        .catch((err) => {
          $confirmRegistrationBtn.prop("disabled", false).removeClass("btn-loading");

          if (err.code === "E73491") {
            // Username already exists
            $formFeedback.text(LanguageManager.getValueForKey("register.errors.username_exists"));
            registerFormValidator.setValid("email", false);
          } else {
            $formFeedback.text(LanguageManager.getValueForKey("register.errors.unexpected"));
          }

          $("#register-eula-form").removeClass("form-active");
          $("#register-form").addClass("form-active");
        });
    }
  }

  function login(username, password) {
    return LoginManager.login(username, password)
      .then((data) => {
        let loginData = data.loginData;
        StorageController.saveToLocal(StorageController.keys.LOGGED_IN_USER, loginData);
        utils.redirect("/teacher/sessions");
      })
      .catch((appError) => {
        log.error("Login failed - redirecting to login page so that user can try to manually login");
        utils.redirect("/login");
      });
  }

})(RegisterPage);



// WEBPACK FOOTER //
// ./app/js/entries/register.js